import { Component, OnInit, ViewChild } from '@angular/core';
import { MasterDataService } from 'src/app/services/master-data.service';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MasterDataCommon } from '../master-data.common';
import { MatOption } from '@angular/material/core';
import { CommonMessageService } from 'src/app/services/common-message.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-manage-task',
  templateUrl: './manage-task.component.html',
  styleUrls: ['./manage-task.component.css']
})
export class ManageTaskComponent implements OnInit {
  taskList:any;
  assignmentList:any;
  modalForm:any;
  modalStatus:any;
  formSubmitted=false;
  formErrors = MasterDataCommon.taskFormErrors;
  formValidationMessages = MasterDataCommon.taskFormValidationMessages;
  @ViewChild('allSelected') private allSelected: MatOption;

  constructor(private masterDataService:MasterDataService,private fb: FormBuilder,private modalService: NgbModal,
    private commonMessageService:CommonMessageService) { }

  ngOnInit(): void {
    this.initModalForm();
    this.loadTasks();
  }

  loadTasks(){
    this.masterDataService.getTasks()
    .subscribe(res => {
      console.log(res);
      this.taskList = res;
      this.loadAssignments();
    });
  }

  loadAssignments(){
    this.masterDataService.getAssignments()
    .subscribe(res => {
      console.log(res);
      this.assignmentList = res;
    });
  }

  initModalForm(){
    this.modalForm = this.fb.group({
      id:[''],
      name :  ['', [Validators.required,Validators.maxLength(50)]],
      assignments :  ['', [Validators.required]],
    });
  }

  // Modal Code
  openModal(content,status) {
    this.modalStatus = status;
    if(!(this.modalStatus=='edit')){
      this.resetModalForm();
    }
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title',size: 'md',windowClass : "animate__animated animate__slideInUp animate__faster"}).result.then((result) => {
    }, (reason) => {
    });
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  resetModalForm(){
    this.formSubmitted = false;
    this.modalForm.reset();
  }

  onDeleteClick(task){
    Swal.fire({
      text: 'Are you sure you want to remove?',
      showCancelButton: true,
      confirmButtonText: 'Ok',
      confirmButtonColor:'#800000'
    }).then((result) => {
      if (result.isConfirmed) {
        this.modalStatus = 'delete';
        this.masterDataService.deleteTask(task)
        .subscribe(resp => {
          console.log(resp);
          this.changeTaskList(task);
          this.commonMessageService.swalAlertWithIcon('','Deleted Successfully!','success');
        })
      }
    })
  }

  onSaveClick(){
    console.log(this.modalForm.value);
    this.formSubmitted=true;
    this.logValidationErrors(this.modalForm);
    if(this.modalForm.valid){
      this.masterDataService.saveTask(this.modalForm.value)
      .subscribe(resp => {
        console.log(resp);
        this.changeTaskList(resp);
        this.closeModal();
        this.commonMessageService.swalAlertWithIcon('','Saved Successfully!','success');
      })
    }
  }
  // ----------------------------
  compareItems(i1, i2) {
    return i1 && i2 && i1.id===i2.id;
  }

  setValueToModalForm(task){
    console.log(task)
    this.modalForm.patchValue({
      name: task.name,
      id:task.id,
    });
    this.modalForm.controls.assignments.setValue(task.assignments);
    console.log(this.modalForm.controls.assignments);
  }

  viewTask(task,content){
    this.masterDataService.viewTask(task.id)
    .subscribe(resp => {
      console.log(resp);
      this.setValueToModalForm(resp);
      this.openModal(content,'edit');
    })
  }

  onEditClick(modalContent,task){
    console.log(task);
    this.viewTask(task,modalContent);
  }

  onUpdateClick(){
    console.log(this.modalForm);
    console.log(this.modalForm.value);
    this.formSubmitted=true;
    this.logValidationErrors(this.modalForm);
    if(this.modalForm.valid){
      this.masterDataService.updateTask(this.modalForm.value)
      .subscribe(resp => {
        console.log(resp);
        this.changeTaskList(resp);
        this.closeModal();
          this.commonMessageService.swalAlertWithIcon('','Updated Successfully!','success');
      })
    }
  }

  //Setting
  changeTaskList(task){
    if(this.modalStatus=='add'){
      this.taskList.push(task);
    }
    if(this.modalStatus=='edit'){
      var index = this.taskList.findIndex(item => item.id === task.id)
      this.taskList.splice(index, 1, task);
    }
    if(this.modalStatus=='delete'){
      var index = this.taskList.findIndex(item => item.id === task.id)
      this.taskList.splice(index, 1);
    }
  }

  selectAll(ev){
    console.log(ev);
    if(ev._selected){
    this.modalForm.controls.assignments
    .patchValue(this.assignmentList);
    ev._selected=true;
    }
    if(ev._selected==false){
    this.modalForm.controls.assignments.patchValue([]);
    }
  }

  togglePerOne(ev){
    // console.log(ev);
    // console.log(this.modalForm.controls.assignments.value.length);
    // console.log(this.assignmentList.length);
    if(this.modalForm.controls.assignments.value.length==this.assignmentList.length){
      // ev._selected=true;
      // this.selectAll(ev);
    }else{
      ev._selected=false;
    }

  }


//   togglePerOne(all){
//     if (this.allSelected.selected) {
//      this.allSelected.deselect();
//      return false;
//  }
//    if(this.modalForm.controls.assignments.value.length==this.assignmentList.length)
//      this.allSelected.select();

//  }

  logValidationErrors(group: FormGroup): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      if (abstractControl instanceof FormGroup) {
        this.logValidationErrors(abstractControl);
      } else {
        console.log('Key = ' + key + ' && Value = ' + abstractControl.value);
        this.formErrors[key] = '';
        if (abstractControl && !abstractControl.valid && this.formSubmitted) {
          const messages = this.formValidationMessages[key];
          for (const errorKey in abstractControl.errors) {
            console.log(errorKey)
            if (errorKey) {
              this.formErrors[key] += messages[errorKey] + ' ';
            }
          }
        }
      }
    });
  }


}
